export const Truck = ({ className }: { className?: string }) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.3496 2.92V11.23C14.3496 12.25 13.5196 13.08 12.4996 13.08H3.34961C2.79961 13.08 2.34961 12.63 2.34961 12.08V5.69C2.34961 3.65 3.99961 2 6.03961 2H13.4196C13.9396 2 14.3496 2.41 14.3496 2.92Z"
      fill="currentColor"
    />
    <path
      d="M21.8496 15.5C22.1296 15.5 22.3496 15.72 22.3496 16V17C22.3496 18.66 21.0096 20 19.3496 20C19.3496 18.35 17.9996 17 16.3496 17C14.6996 17 13.3496 18.35 13.3496 20H11.3496C11.3496 18.35 9.99961 17 8.34961 17C6.69961 17 5.34961 18.35 5.34961 20C3.68961 20 2.34961 18.66 2.34961 17V15C2.34961 14.45 2.79961 14 3.34961 14H12.8496C14.2296 14 15.3496 12.88 15.3496 11.5V6C15.3496 5.45 15.7996 5 16.3496 5H17.1896C17.9096 5 18.5696 5.39 18.9296 6.01L19.5696 7.13C19.6596 7.29 19.5396 7.5 19.3496 7.5C17.9696 7.5 16.8496 8.62 16.8496 10V13C16.8496 14.38 17.9696 15.5 19.3496 15.5H21.8496Z"
      fill="currentColor"
    />
    <path
      d="M8.34961 22C9.45418 22 10.3496 21.1046 10.3496 20C10.3496 18.8954 9.45418 18 8.34961 18C7.24504 18 6.34961 18.8954 6.34961 20C6.34961 21.1046 7.24504 22 8.34961 22Z"
      fill="currentColor"
    />
    <path
      d="M16.3496 22C17.4542 22 18.3496 21.1046 18.3496 20C18.3496 18.8954 17.4542 18 16.3496 18C15.245 18 14.3496 18.8954 14.3496 20C14.3496 21.1046 15.245 22 16.3496 22Z"
      fill="currentColor"
    />
    <path
      d="M22.3496 12.53V14H19.3496C18.7996 14 18.3496 13.55 18.3496 13V10C18.3496 9.45 18.7996 9 19.3496 9H20.6396L22.0896 11.54C22.2596 11.84 22.3496 12.18 22.3496 12.53Z"
      fill="currentColor"
    />
  </svg>
);

export const TruckFeature = () => (
  <svg
    width="64"
    height="72"
    viewBox="0 0 64 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2095_43673)">
      <circle cx="28" cy="24" r="20" fill="url(#paint0_linear_2095_43673)" />
      <circle cx="28" cy="24" r="22" stroke="white" strokeWidth="4" />
    </g>
    <path
      d="M32.9987 29.4173C32.6672 29.4173 32.3492 29.2856 32.1148 29.0512C31.8804 28.8168 31.7487 28.4988 31.7487 28.1673C31.7487 27.8358 31.8804 27.5179 32.1148 27.2834C32.3492 27.049 32.6672 26.9173 32.9987 26.9173C33.3302 26.9173 33.6482 27.049 33.8826 27.2834C34.117 27.5179 34.2487 27.8358 34.2487 28.1673C34.2487 28.4988 34.117 28.8168 33.8826 29.0512C33.6482 29.2856 33.3302 29.4173 32.9987 29.4173ZM34.2487 21.9173L35.882 24.0006H32.1654V21.9173H34.2487ZM22.9987 29.4173C22.6672 29.4173 22.3492 29.2856 22.1148 29.0512C21.8804 28.8168 21.7487 28.4988 21.7487 28.1673C21.7487 27.8358 21.8804 27.5179 22.1148 27.2834C22.3492 27.049 22.6672 26.9173 22.9987 26.9173C23.3302 26.9173 23.6482 27.049 23.8826 27.2834C24.117 27.5179 24.2487 27.8358 24.2487 28.1673C24.2487 28.4988 24.117 28.8168 23.8826 29.0512C23.6482 29.2856 23.3302 29.4173 22.9987 29.4173ZM34.6654 20.6673H32.1654V17.334H20.4987C19.5737 17.334 18.832 18.0757 18.832 19.0007V28.1673H20.4987C20.4987 28.8304 20.7621 29.4662 21.2309 29.9351C21.6998 30.4039 22.3357 30.6673 22.9987 30.6673C23.6617 30.6673 24.2976 30.4039 24.7665 29.9351C25.2353 29.4662 25.4987 28.8304 25.4987 28.1673H30.4987C30.4987 28.8304 30.7621 29.4662 31.2309 29.9351C31.6998 30.4039 32.3357 30.6673 32.9987 30.6673C33.6617 30.6673 34.2976 30.4039 34.7665 29.9351C35.2353 29.4662 35.4987 28.8304 35.4987 28.1673H37.1654V24.0006L34.6654 20.6673Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_2095_43673"
        x="0"
        y="0"
        width="64"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="16" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2095_43673"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2095_43673"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2095_43673"
        x1="8"
        y1="4"
        x2="48"
        y2="44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C41719" />
        <stop offset="1" stopColor="#EF5F21" />
      </linearGradient>
    </defs>
  </svg>
);

export const WhiteTruck = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.75 8.21875H0.75V1.45833C0.75 1.33678 0.798295 1.2202 0.884249 1.13424C0.970204 1.04829 1.08678 1 1.20833 1H11.2917C11.4132 1 11.5298 1.04829 11.6158 1.13424C11.7017 1.2202 11.75 1.33678 11.75 1.45833V8.21875ZM11.75 8.21875V10.7969H4.27C4.16405 10.4949 3.96691 10.2332 3.70581 10.0481C3.44471 9.86302 3.13256 9.76359 2.8125 9.76359C2.49244 9.76359 2.18029 9.86302 1.91919 10.0481C1.65809 10.2332 1.46095 10.4949 1.355 10.7969H1.20833C1.08678 10.7969 0.970204 10.7486 0.884249 10.6626C0.798295 10.5767 0.75 10.4601 0.75 10.3385V8.21875H11.75ZM12.4123 10.7969H12.411H11.75M11.75 3.0625H14.9583C15.027 3.06254 15.0948 3.07801 15.1566 3.10776C15.2185 3.13751 15.2729 3.18078 15.3158 3.23438L17.1492 5.52604C17.2143 5.6073 17.2499 5.70833 17.25 5.8125V10.3477C17.25 10.4693 17.2017 10.5858 17.1158 10.6718C17.0298 10.7578 16.9132 10.806 16.7917 10.806H15.3273M13.5833 3.07166V5.70708C13.5833 5.82864 13.6316 5.94522 13.7176 6.03117C13.8035 6.11712 13.9201 6.16541 14.0417 6.16541H17.25M4.35938 11.3217C4.35938 11.7319 4.1964 12.1254 3.9063 12.4155C3.61621 12.7056 3.22276 12.8685 2.8125 12.8685C2.40224 12.8685 2.00879 12.7056 1.7187 12.4155C1.4286 12.1254 1.26562 11.7319 1.26562 11.3217C1.26451 11.1458 1.29478 10.9712 1.355 10.806C1.46095 10.504 1.65809 10.2424 1.91919 10.0573C2.18029 9.87219 2.49244 9.77276 2.8125 9.77276C3.13256 9.77276 3.44471 9.87219 3.70581 10.0573C3.96691 10.2424 4.16405 10.504 4.27 10.806C4.33022 10.9712 4.36049 11.1458 4.35938 11.3217ZM15.4167 11.3217C15.4174 11.7098 15.2724 12.0841 15.0104 12.3704C14.7484 12.6568 14.3884 12.8343 14.0017 12.868C13.6151 12.9016 13.2299 12.7889 12.9223 12.5521C12.6148 12.3153 12.4074 11.9716 12.3411 11.5892C12.2947 11.3216 12.3198 11.0486 12.411 10.7969C12.4501 10.6889 12.5014 10.5849 12.5644 10.4869C12.7743 10.1604 13.0991 9.92461 13.4745 9.82614C13.85 9.72768 14.2487 9.77373 14.5918 9.9552C14.9349 10.1367 15.1974 10.4403 15.3273 10.806C15.3861 10.9716 15.4164 11.146 15.4167 11.3217Z"
        fill="white"
      />
      <path
        d="M11.75 3.0625V8.21875V10.7969H12.411C12.4501 10.6889 12.5014 10.5849 12.5644 10.4869C12.7743 10.1604 13.0991 9.92461 13.4745 9.82614C13.85 9.72768 14.2487 9.77373 14.5918 9.9552C14.9349 10.1367 15.1974 10.4403 15.3273 10.806H16.7917C16.9132 10.806 17.0298 10.7578 17.1158 10.6718C17.2017 10.5858 17.25 10.4693 17.25 10.3477V6.16541V5.8125C17.2499 5.70833 17.2143 5.6073 17.1492 5.52604L15.3158 3.23438C15.2729 3.18078 15.2185 3.13751 15.1566 3.10776C15.0948 3.07801 15.027 3.06254 14.9583 3.0625H11.75Z"
        fill="white"
      />
      <path
        d="M11.75 8.21875H0.75M11.75 8.21875V1.45833C11.75 1.33678 11.7017 1.2202 11.6158 1.13424C11.5298 1.04829 11.4132 1 11.2917 1H1.20833C1.08678 1 0.970204 1.04829 0.884249 1.13424C0.798295 1.2202 0.75 1.33678 0.75 1.45833V8.21875M11.75 8.21875V10.7969M11.75 8.21875V3.0625H14.9583C15.027 3.06254 15.0948 3.07801 15.1566 3.10776C15.2185 3.1375 15.2729 3.18078 15.3158 3.23438L17.1492 5.52604C17.2143 5.6073 17.2499 5.70833 17.25 5.8125M0.75 8.21875V10.3385C0.75 10.4601 0.798295 10.5767 0.884249 10.6626C0.970204 10.7486 1.08678 10.7969 1.20833 10.7969H1.355C1.46095 10.4949 1.65809 10.2332 1.91919 10.0481C2.18029 9.86302 2.49244 9.76359 2.8125 9.76359C3.13256 9.76359 3.44471 9.86302 3.70581 10.0481C3.96691 10.2332 4.16405 10.4949 4.27 10.7969H11.75M11.75 10.7969H12.411M12.4123 10.7969H12.411M17.25 5.8125V10.3477M17.25 5.8125V6.16541M17.25 10.3477C17.25 10.4693 17.2017 10.5858 17.1158 10.6718C17.0298 10.7578 16.9132 10.806 16.7917 10.806H15.3273M17.25 10.3477V6.16541M15.3273 10.806C15.1974 10.4403 14.9349 10.1367 14.5918 9.9552C14.2487 9.77373 13.85 9.72768 13.4745 9.82614C13.0991 9.92461 12.7743 10.1604 12.5644 10.4869C12.5014 10.5849 12.4501 10.6889 12.411 10.7969M15.3273 10.806C15.3861 10.9716 15.4164 11.146 15.4167 11.3217C15.4174 11.7098 15.2724 12.0841 15.0104 12.3704C14.7484 12.6568 14.3884 12.8343 14.0017 12.868C13.6151 12.9016 13.2299 12.7889 12.9223 12.5521C12.6148 12.3153 12.4074 11.9716 12.3411 11.5892C12.2947 11.3216 12.3198 11.0486 12.411 10.7969M13.5833 3.07166V5.70708C13.5833 5.82864 13.6316 5.94522 13.7176 6.03117C13.8035 6.11712 13.9201 6.16541 14.0417 6.16541H17.25M4.35938 11.3217C4.35937 11.7319 4.1964 12.1254 3.9063 12.4155C3.61621 12.7056 3.22276 12.8685 2.8125 12.8685C2.40224 12.8685 2.00879 12.7056 1.7187 12.4155C1.4286 12.1254 1.26562 11.7319 1.26562 11.3217C1.26451 11.1458 1.29478 10.9712 1.355 10.806C1.46095 10.504 1.65809 10.2424 1.91919 10.0573C2.18029 9.87219 2.49244 9.77276 2.8125 9.77276C3.13256 9.77276 3.44471 9.87219 3.70581 10.0573C3.96691 10.2424 4.16405 10.504 4.27 10.806C4.33022 10.9712 4.36049 11.1458 4.35938 11.3217Z"
        stroke="black"
        strokeWidth="0.5625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.65 8.11875H0.85V1.45833C0.85 1.3633 0.887757 1.27216 0.95496 1.20495C1.02216 1.13775 1.1133 1.1 1.20833 1.1H11.2917C11.3867 1.1 11.4778 1.13775 11.545 1.20495C11.6122 1.27216 11.65 1.3633 11.65 1.45833V8.11875Z"
        fill="#C41719"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M3.03722 3.15625L2.35889 5.53271H2.93868L3.59868 3.15854L3.03722 3.15625Z"
        fill="white"
      />
      <path
        d="M4.54047 3.16099L3.88506 3.88286L3.65589 3.15869L3.40381 4.00661L3.59401 4.85452L4.29527 4.0089L4.54047 3.16099Z"
        fill="white"
      />
      <path
        d="M4.48555 5.53759L5.1616 3.16113H4.57951L3.90576 5.5353L4.48555 5.53759Z"
        fill="white"
      />
      <path
        d="M5.7711 5.54184L6.42882 5.54413L6.13549 4.27913L7.05673 3.16767L6.50444 3.16538L6.01173 3.77038L5.87194 3.16309H5.21882L5.49381 4.35246L3.71777 6.46309H4.27923L5.61757 4.88872L5.7711 5.54184Z"
        fill="white"
      />
      <path
        d="M5.12024 5.6748H5.0217L4.86816 6.22251H5.22337L5.2417 6.1423L4.98733 6.13772L5.12024 5.6748Z"
        fill="white"
      />
      <path
        d="M5.55102 6.09433L5.5052 6.13329H5.38374L5.35624 6.09892L5.44103 5.801L5.48456 5.76662H5.60373L5.63581 5.801L5.55102 6.09433ZM5.67249 5.67725H5.46623L5.35394 5.75975L5.24854 6.13787L5.31727 6.22725H5.51664L5.63581 6.13329L5.74125 5.76204L5.67249 5.67725Z"
        fill="white"
      />
      <path
        d="M5.98452 6.021L5.96618 6.1035L5.92264 6.13558L5.80806 6.13329L5.78285 6.09433L5.86306 5.80787L5.91119 5.76892H6.02806L6.04869 5.80787L6.03264 5.87204L6.13118 5.87433L6.15868 5.75746L6.09452 5.67725H5.89973L5.77598 5.77121L5.67285 6.1287L5.74848 6.22954H5.93869L6.05327 6.13787L6.08306 6.02329L5.98452 6.021Z"
        fill="white"
      />
      <path
        d="M6.61626 5.67954H6.51084L6.26105 5.89954L6.32064 5.67954L6.2198 5.67725L6.06396 6.22954H6.16939L6.22209 6.03933L6.31605 5.95683L6.36876 6.23183H6.46501L6.39626 5.87891L6.61626 5.67954Z"
        fill="white"
      />
      <path
        d="M6.66471 5.9799H6.84804L6.86637 5.90656H6.68304L6.7197 5.77135H6.98554L7.01074 5.67969H6.65554L6.49512 6.23198H6.85491L6.88012 6.14031H6.62116L6.66471 5.9799Z"
        fill="white"
      />
      <path
        d="M7.07724 5.91554L7.11621 5.77346H7.26056L7.2812 5.79867L7.26285 5.88346L7.22391 5.92013L7.07724 5.91554ZM7.34993 5.91554L7.3912 5.75971L7.33391 5.68408H7.04974L6.8916 6.23637H6.98786L7.05204 6.00721H7.11847L7.15515 6.23637H7.2537L7.21473 6.00721H7.24223L7.34993 5.91554Z"
        fill="white"
      />
    </svg>
  );
};
